import React from "react";

const UserCancel = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
          className="u_fill"
          d="M19.346 22.194V34H4c0-1.86.428-3.697 1.253-5.368a12.209 12.209 0 013.504-4.272 12.317 12.317 0 015.041-2.303 12.36 12.36 0 015.548.137zm-3.07-1.908c-5.087 0-9.207-4.092-9.207-9.143C7.07 6.09 11.19 2 16.276 2c5.087 0 9.208 4.091 9.208 9.143 0 5.051-4.12 9.143-9.208 9.143zm10.742 5.464l3.255-3.233 2.171 2.156-3.256 3.232 3.256 3.232-2.17 2.156-3.256-3.234-3.255 3.234-2.17-2.156 3.255-3.232-3.256-3.232 2.172-2.156 3.254 3.233z"
          fill={fill}
      />
    </svg>
);
export default UserCancel;
